export default "__VITE_ASSET__DkYD2Shi__"